import { useEffect, useState } from 'react';

interface UseObjectDetailsViewportParams {
  scrollParent: HTMLDivElement | null;
  stickyToolbar: HTMLDivElement | null;
}

export const useObjectDetailsViewport = ({
  scrollParent,
  stickyToolbar,
}: UseObjectDetailsViewportParams) => {
  const [viewportHeight, setViewportHeight] = useState(0);
  const [toolbarHeight, setToolbarHeight] = useState(0);

  useEffect(() => {
    if (!scrollParent || !stickyToolbar) {
      return;
    }

    const observer = new ResizeObserver(() => {
      setViewportHeight(scrollParent.clientHeight);
      setToolbarHeight(stickyToolbar.offsetHeight);
    });

    observer.observe(scrollParent);
    observer.observe(stickyToolbar);

    return () => observer.disconnect();
  }, [scrollParent, stickyToolbar]);

  return {
    toolbarHeight,
    detailsHeight: Math.max(viewportHeight - toolbarHeight, 0),
  };
};
